import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetchStatistics(startedAt, finishedAt) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          	whatsAppDispatchStatistics(
  	        	started_at: "${startedAt}",
  	        	finished_at: "${finishedAt}"
  	    	) {
  	        	sent,
  	        	received
  	    	}
        }
      `
    })
  },
  chatTicketsAnalyticsReport(startedAt, finishedAt) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatTicketsAnalyticsReport(
            started_at: "${startedAt}",
            finished_at: "${finishedAt}"
          ) {
            user {
              name,
              image
            },
            chat_tickets_count,
            average_chat_tickets_per_user,
            sent_messages,
            received_messages,
            average_wait_answer
          }
        }
      `
    })
  },
  chatTicketsCount(startedAt, finishedAt) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatTicketsCount(
            started_at: "${startedAt}",
            finished_at: "${finishedAt}"
          ) {
            chat_tickets_count
          }
        }
      `
    })
  },
  chatTicketsCountByInstance(startedAt, finishedAt) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatTicketsCountByInstance(
            started_at: "${startedAt}",
            finished_at: "${finishedAt}"
          ) {
            instanceName,
            count
          }
        }
      `
    })
  },
  chatTicketsCountByDepartment(startedAt, finishedAt) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatTicketsCountByDepartment(
            started_at: "${startedAt}",
            finished_at: "${finishedAt}"
          ) {
            departmentName,
            count
          }
        }
      `
    })
  },
  fetchDashboardGraphs(startedAt, finishedAt) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          dashboardGraphs (
            started_at: "${startedAt}",
            finished_at: "${finishedAt}"
        ){
            first_messages_received,
            main_messages_received,
            campaign_messages,
            messages_sent_by_bot,
            customers_in_blacklist,
            customers_interactions,
            calls_for_user,
            average_wait_answer
          }
        }
      `
    })
  },
  fetchDashboardGraphsBetween(startedAt, finishedAt) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          dashboardGraphs(
            started_at: "${startedAt}",
  	        finished_at: "${finishedAt}"
          ) {
            first_messages_received,
            main_messages_received,
            campaign_messages,
            customers_in_blacklist,
            customers_interactions,
            calls_for_user,
            messages_sent_by_bot,
            average_wait_answer
          }
        }
      `
    })
  },
  connectionStatus(instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          connectionStatus (
            instance_id: ` + instanceId + `
          )
        }
      `
    })
  },
  getOfficialPhoneNumbers(instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          getOfficialPhoneNumbers (
            instance_id: ` + instanceId + `
          ) {
            waba_id,
            phone_number,
            display_name,
            messaging_send,
            messaging_limit,
            official_phone_id,
            business_initiated_conversations
          }
        }
      `
    })
  },
  getOfficialMessageTemplates(instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          getOfficialMessageTemplates (
            instance_id: ` + instanceId + `
          ) {
            id
            name,
            components {
              type,
              text,
              format,
              buttons {
                  type,
                  text
              }
            },
            language,
            status,
            category
          }
        }
      `
    })
  },
  sendLgpdLink(lgpdLink, instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          sendLgpdLink (
            lgpd_link: "` + lgpdLink + `",
            instance_id: ` + instanceId + `
          )
        }
      `
    })
  }
}
